import i18n from "src/i18n";


export const getMonths = () => [
  { label: i18n.t("january"), value: "january" },
  { label: i18n.t("february"), value: "february" },
  { label: i18n.t("march"), value: "march" },
  { label: i18n.t("april"), value: "april" },
  { label: i18n.t("may"), value: "may" },
  { label: i18n.t("june"), value: "june" },
  { label: i18n.t("july"), value: "july" },
  { label: i18n.t("august"), value: "august" },
  { label: i18n.t("september"), value: "september" },
  { label: i18n.t("october"), value: "october" },
  { label: i18n.t("november"), value: "november" },
  { label: i18n.t("december"), value: "december" },
];

export const getDays = () => [
  { label: i18n.t("monday"), value: "monday" },
  { label: i18n.t("tuesday"), value: "tuesday" },
  { label: i18n.t("wednesday"), value: "wednesday" },
  { label: i18n.t("thursday"), value: "thursday" },
  { label: i18n.t("friday"), value: "friday" },
  { label: i18n.t("saturday"), value: "saturday" },
  { label: i18n.t("sunday"), value: "sunday" },
];

export const getCategories = () => [
  { label: i18n.t("consultation"), value: "consultation" },
  { label: i18n.t("laboratory"), value: "laboratory" },
  { label: i18n.t("radiology"), value: "radiology" },
  { label: i18n.t("prescription"), value: "prescription" },
  { label: i18n.t("immunization"), value: "immunization" },
  { label: i18n.t("footnote"), value: "footnote" },
  { label: i18n.t("treatment"), value: "treatment" },
];
